module.exports = __webpack_public_path__ + "img/txt-pro.4a92cd20.png";